export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_LIMIT = 20;
export const MAX_PAGE_SIZE = 100;
export const DEFAULT_PAGE = 1;
export const PAGINATION = {
  DEFAULT_PAGE,
  DEFAULT_LIMIT,
  DEFAULT_PAGE_SIZE,
  MAX_PAGE_SIZE
};
//# sourceMappingURL=pagination.js.map